/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";
import { ApolloProvider } from "@apollo/client";
import { client } from "./graphql";
import VerificationEmail from "pages/LandingPages/verification/Verification";
import VerifyEmail from "pages/LandingPages/Verify_Email";
import ProvertyRates from "pages/LandingPages/PovertyRates";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApolloProvider client={client}>
        <Routes>
          {getRoutes(routes)}
          <Route
            path="/county-poverty-rate-individual-income-and-intention-to-leave-hospitality-industry-size-of-circle"
            element={<ProvertyRates />}
          />
          <Route path="/" element={<Presentation />} />
          <Route path="/verification" element={<VerificationEmail />} />
          <Route path="/verify_email" element={<VerifyEmail />} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </ApolloProvider>
    </ThemeProvider>
  );
}
